var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "import-lightbox-container",
      class: { "import-lightbox-modal": _vm.isModal },
      on: {
        mousedown: function ($event) {
          $event.stopPropagation()
        },
        touchstart: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "hammer",
              rawName: "v-hammer:pan",
              value: _vm.onPan,
              expression: "onPan",
              arg: "pan",
            },
            {
              name: "hammer",
              rawName: "v-hammer:pinch",
              value: _vm.onPinch,
              expression: "onPinch",
              arg: "pinch",
            },
            {
              name: "hammer",
              rawName: "v-hammer:pinchend",
              value: _vm.onPinchEnd,
              expression: "onPinchEnd",
              arg: "pinchend",
            },
          ],
          staticClass: "import-lightbox-view",
          style: _vm.computedStyles,
        },
        [
          _vm.isLoading
            ? _c("div", { staticClass: "import-lightbox-view-load-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: { viewBox: "0 0 32 32", width: "64", height: "64" },
                  },
                  [
                    _c("circle", {
                      attrs: {
                        id: "spinner",
                        cx: "16",
                        cy: "16",
                        r: "14",
                        fill: "none",
                      },
                    }),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.showCloseButton
            ? _c(
                "div",
                {
                  staticClass: "import-lightbox-view-close-icon",
                  on: { click: _vm.closeLightBox },
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
              )
            : _vm._e(),
        ]
      ),
      _vm.showToolsButtons
        ? _c("div", { staticClass: "import-lightbox-view-tools" }, [
            _vm.showRemoveButton
              ? _c(
                  "div",
                  {
                    staticClass: "import-lightbox-view-remove-button",
                    on: { click: _vm.removePhoto },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("delete_forever"),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("views.importLightBox.deleteButtonText"))
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.showRetryButton
              ? _c(
                  "div",
                  {
                    staticClass: "import-lightbox-view-retry-button",
                    on: { click: _vm.retryUpload },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("refresh"),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("views.importLightBox.retryButtonText"))
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "import-lightbox-view-close-button",
                on: { click: _vm.closeLightBox },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("views.importLightBox.closeButtonText"))
                  ),
                ]),
              ]
            ),
            _vm.showSelectButton
              ? _c(
                  "div",
                  {
                    staticClass: "import-lightbox-view-select-button",
                    on: { click: _vm.selectPhoto },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("check"),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("views.importLightBox.selectButtonText"))
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }